module.exports = __webpack_public_path__ + "static/img/chengcai1.b851bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chengcai1.png
// module id = fj1y
// module chunks = 52